import { createAction, props } from '@ngrx/store';
import { ServiceInventoryItem } from './service-inventory.model';

export const loadServiceInventory = createAction('[Service Inventory] Load');
export const loadServiceInventorySuccess = createAction(
  '[Service Inventory] Load Success',
  props<{ items: ServiceInventoryItem[] }>()
);
export const loadServiceInventoryFailure = createAction(
  '[Service Inventory] Load Failure',
  props<{ error: string }>()
);
export const updateServiceState = createAction(
  '[Service Inventory] Update Service State',
  props<{ key: string; state: ServiceInventoryItem['state'] }>()
);
export const deleteServiceState = createAction(
  '[Service Inventory] Delete Service State',
  props<{ key: string }>()
);
